import { Avatar } from "antd";
import { CustomPagination, CommonColorButton } from "components";
import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
`;

const StyledAvatar = styled(Avatar)`
  width: 36px;
  height: 36px;
  margin-right: 8px;
`;

const Title = styled.span`
  font-family: Roboto;
  font-weight: 600;
  font-size: 14px;
  color: #000;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const ListItem = ({ imageUrl, title, onRemove }) => {
    return (
        <Container>
            <LeftSection>
                <StyledAvatar src={imageUrl} alt="Profile" />
                <Title>{title}</Title>
            </LeftSection>
            <CommonColorButton title="Restore" variant="green" onClick={() => onRemove("Other clicked")} />
        </Container>
    );
};

const items = [
    { id: 1, imageUrl: "https://via.placeholder.com/24", title: "Guitar for the Pixies" },
    { id: 2, imageUrl: "https://via.placeholder.com/24", title: "Skyline Dreams" },
    { id: 3, imageUrl: "https://via.placeholder.com/24", title: "Ocean Beats" },
];
export const RemovedParticipantsList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = 1;

    const handleRemove = (id) => {
        console.log(`Remove item with ID: ${id}`);
    };

    return <div>
        {items.map((item) => (
            <ListItem
                key={item.id}
                imageUrl={item.imageUrl}
                title={item.title}
                onRemove={() => handleRemove(item.id)}
            />
        ))}
        <CustomPagination totalPages={totalPages} currentPage={currentPage} onPageChange={setCurrentPage} />
    </div>
}